import utils from 'intl-tel-input/utils';

export const PhoneNumberFormat = {
  E164: '0',
  INTERNATIONAL: '1',
  NATIONAL: '2',
  RFC3966: '3',
};
export const ParsePhoneNumber = (phoneNumberString, countryCode = 'BE', format = PhoneNumberFormat.INTERNATIONAL) =>
  phoneNumberString ? utils.formatNumber(phoneNumberString, countryCode, format) : '';

export const IsValidPhoneNumber = (phoneNumberString, countryCode = 'BE') =>
  utils.isValidNumber(phoneNumberString, countryCode);
